/* eslint-disable no-prototype-builtins */
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Divider,
  TextField,
  Grid,
  Switch
} from '@material-ui/core';
import JoditEditor from 'jodit-react';
import {
  changeAboutUsPageConfigConfig
} from 'redux/actions/store_configs';


const config: unknown = {
  'minHeight': 100,
  'showXPathInStatusbar': false,
  'spellcheck': false,
  'askBeforePasteHTML': false,
  'askBeforePasteFromWord': false,
  'toolbar': false,
  'showCharsCounter': false,
  'showWordsCounter': false,
  'enter': 'BR',
  'placeholder': 'Text'
};

const AboutUsPageWelcomeBlock = ({values, onChange}) => {
  const dispatch = useDispatch();
  const { main_welcome_section } = values;

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeAboutUsPageConfigConfig(name, checked, type, value, 'main_welcome_section'));
  };

  const handleChangeContent = (value, name) => {
    dispatch(changeAboutUsPageConfigConfig(name, null, 'textarea', value, 'main_welcome_section'));
  };

  return (
    <div>
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            name={'store_info/about_us_page/is_main_content_enabled'}
            checked={main_welcome_section['store_info/about_us_page/is_main_content_enabled'] == 1}
            onChange={(event) => {
              onChange('main_welcome_section[\'store_info/about_us_page/is_main_content_enabled\']', event.target.checked ? 1 : 0);
              handleChange(event);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="my-2 ml-4">Heading Text</Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            fullWidth
            variant="outlined"
            name={'store_info/about_us_page/main_content_heading'}
            label="Text"
            value={main_welcome_section['store_info/about_us_page/main_content_heading']}
            onChange={(event) => {
              onChange('main_welcome_section[\'store_info/about_us_page/main_content_heading\']', event.target.value);
              handleChange(event);
            }}
            inputProps={{
              shrink: 'true'
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2} className="ml-4">Content Text</Grid>
        <Grid item xs={12} sm={9}>
          <JoditEditor
            value={main_welcome_section['store_info/about_us_page/main_content_text']}
            config={config}
            onChange={(newContent) => {
              const content = newContent.replace(/style="(.*?)"/gm, '');
              onChange('main_welcome_section[\'store_info/about_us_page/main_content_text\']', content);
              handleChangeContent(content, 'store_info/about_us_page/main_content_text');
            }}
            onBlur={(newContent) => {
              const content = newContent.replace(/style="(.*?)"/gm, '');
              onChange('main_welcome_section[\'store_info/about_us_page/main_content_text\']', content);
              handleChangeContent(content, 'store_info/about_us_page/main_content_text');
            }}
          />
        </Grid>
      </Grid>
      <Divider className="my-8" />
    </div>
  );
};

export default AboutUsPageWelcomeBlock;
